import { useQueryClient } from '@tanstack/react-query';
import { LockKeyhole } from 'lucide-react';
import { SignInForm } from './SignInForm.js';
import './login.css';

interface SessionExpiredDialogProps {
  readonly email: string;
}

/**
 * Shown over the screen when the session ended (inactivity, sign-out
 * elsewhere, suspension): the page underneath stays as it was, so the draft
 * in progress is still there after signing in again (functional §9.2).
 */
export function SessionExpiredDialog({ email }: SessionExpiredDialogProps) {
  const queryClient = useQueryClient();

  return (
    <div className="session-dialog" role="dialog" aria-modal="true" aria-labelledby="session-dialog-title">
      <div className="login__card session-dialog__card">
        <span className="session-dialog__icon" aria-hidden>
          <LockKeyhole size={18} />
        </span>
        <h2 id="session-dialog-title" className="login__title">
          Session expirée
        </h2>
        <p className="login__sub">
          Pour votre sécurité, la session se ferme après une période d'inactivité. Saisissez de nouveau votre
          mot de passe : votre travail en cours est conservé.
        </p>
        <SignInForm email={email} onSignedIn={() => void queryClient.invalidateQueries()} />
      </div>
    </div>
  );
}
